import { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";

// TODO - Dark mode momentaneamente disabilitato
// vecchio codice slider
//<Menu.Item
//    key={"darkMode"}
//    onClick={() => toggleDarkMode()}
//    icon={<BulbOutlined filled={darkMode ? 1 : 0} />}>
//    <div style={{ display: "flex", justifyContent: "space-between" }}>
//        <Typography.Text style={{ marginRight: "10px" }}>Dark Mode</Typography.Text>
//        <Switch
//            checked={darkMode}
//            onChange={toggleDarkMode}
//            checkedChildren=""
//            unCheckedChildren=""
//        />
//    </div>
//</Menu.Item>

const useDarkMode = () => {
    const [darkMode, setDarkMode] = useLocalStorage("darkMode", false);

    useEffect(() => {
        //const savedDarkMode = localStorage.getItem("darkMode");
        //if (savedDarkMode !== null) {
        //    setDarkMode(JSON.parse(savedDarkMode));
        //} else {
        //    setDarkMode(false);
        //}
        setDarkMode(false);
    }, []);

    // Toggle tra modalità chiara e scura
    const toggleDarkMode = () => {
        //const newDarkMode = !darkMode;
        //setDarkMode(newDarkMode);
        //localStorage.setItem("darkMode", JSON.stringify(newDarkMode));
        setDarkMode(false);
    };

    return [darkMode, toggleDarkMode];
};

export default useDarkMode;
